export function formatArray(arr) {
  return "[".concat(arr.map(function (item) {
    return "\"".concat(item, "\"");
  }).join(", "), "]");
}